const RatingAbstract = require("components/abstract/Rating");
const PropTypes = require("prop-types");
const assign = require("object-assign");

class Rating extends RatingAbstract {

	static get propTypes() {
		return assign({}, super.propTypes, {
			labels: PropTypes.array,
		});
	}

	static get defaultProps() {
		return assign({}, super.defaultProps, {
			labels: [
				"Udemærket!",
				"Dårlig",
				"Under middel",
				"Middel",
				"God",
				"Perfekt!"
			]
		});
	}

	get label() {
		return (this.props.labels[this.state.value || 0]) || "";
	}

	render() {
		return (
			<div className={this.className}>
				{this.renderStars()}
				<p>{this.label}</p>
				<input type="hidden" name={this.props.name} value={this.state.value || ""}/>
			</div>
		);
	}

}

module.exports = Rating;


// WEBPACK FOOTER //
// ./resources/js/components/widgets/Rating.js